import { email } from 'shared/composables/user';

export const userMatchesSearch = (user, searchTerm) => {
  const tokens = (searchTerm || '').toLowerCase().split(' ').filter((t) => t !== '');
  if (tokens.length === 0) {
    return true;
  }
  const firstName = (user.firstName || '').toLowerCase();
  const lastName = (user.lastName || '').toLowerCase();
  const userEmail = email(user).toLowerCase();
  return tokens.every((token) => firstName.includes(token)
    || lastName.includes(token)
    || userEmail.includes(token));
};
